/* ---------------------------------------------------------------
   Kuno · Datennachtrag · 04.09.2026
   Laedt nach kuno-extra.js, vor kuno-render.js.

   Abgleich Schnappschuss gegen Shop am 04.09.2026:

     Zucker  76 in Kuno gegen 75 im Shop (aktive Artikel mit SKU).
             Es fehlt nichts. Der eine Mehrwert (10014) steht seit
             jeher im Schnappschuss und bleibt.
     Salz    10 in Kuno gegen 27 im Shop. Die fehlenden 17 stehen
             unten.

   Vorhandene Werte werden nie ueberschrieben - nachtragen heisst
   ergaenzen. Wo das Etikett "< 0,1 g" sagt, steht hier die obere
   Schranke 0.1: sie untertreibt nie, und die genaue Schreibweise
   steht auf der Produktseite.
   --------------------------------------------------------------- */
(function () {
  'use strict';
  if (window.KUNO_DATEN) return;
  window.KUNO_DATEN = '2026-09-04';
  if (typeof NAEHRWERT === 'undefined') return;

  /* SKU: Salz je 100 g, Angabe des Erzeugers vom Etikett */
  var SALZ = {
    '10078': 0.1,   /* Bio Superfoods Fruchtgummis      (< 0,1 g)  */
    '10101': 43.9,  /* Dr. Jacob's Blutdruck-Salz 250 g            */
    '10106': 49.3,  /* Dr. Jacob's Blutdruck-Salz 500 g            */
    '10107': 0,     /* Holiston Ultra Premium Olivenoel            */
    '10108': 0,     /* Holiston Premium Olivenoel                  */
    '10123': 0.22,  /* Pistaziencreme LaLola1947                   */
    '10134': 0.1,   /* Matcha Benifuuki Chai                       */
    '10135': 0.11,  /* Matcha Mantoku                              */
    '10138': 0.11,  /* Premium Bio Matcha                          */
    '10165': 0.02,  /* Bio-Pistazienmus LaLola1947                 */
    '10168': 1.2,   /* Bio-Pistazien geroestet + gesalzen          */
    '10169': 0.04,  /* Bio-Pistazienkerne geschaelt                */
    '10170': 0.01,  /* Bio Vitamin C Fruchtgummi     (< 0,01 g)    */
    '10171': 0.01,  /* Bio Kaffee Fruchtgummi        (< 0,01 g)    */
    '10185': 0,     /* SaarNuss Bio-Erdnuesse                      */
    '10240': 0,     /* Premium-Pekannusshaelften Mammoth           */
    '10263': 0      /* Rift-Valley-Datteln                         */
  };

  var neu = 0;
  Object.keys(SALZ).forEach(function (sku) {
    if (!NAEHRWERT[sku]) return;              /* keinen Artikel erfinden */
    if (NAEHRWERT[sku].salz != null) return;  /* nichts ueberschreiben   */
    NAEHRWERT[sku].salz = SALZ[sku];
    neu++;
  });
  window.KUNO_DATEN_NEU = neu;
})();
